import React from "react";
import axios from "axios";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { SelectButton } from "primereact/selectbutton";
import Server from "./../Server.js";
import { Panel } from "primereact/panel";
import { connect } from "react-redux";
import JoditEditor from "jodit-react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import UpFile from "./../UpFile";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const htmlAreaConfig = {
  readonly: false,
  
  controls: {
    font: {
      list: {
        yekan: "yekan",
        YekanBakhFaMedium: "YekanBakhFaMedium",
        YekanBakhFaLight: "YekanBakhFaLight",
        YekanBakhFaBold: "YekanBakhFaBold",
      },
    },
  },
};

class FirstPageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      typeOfContent: "text",
      text_number: 0,
      pic_number: 0,
      slider_number: 0,
      video_number: 0,
      chart_number: 0,
      content: null,
      title: null,
      FixPage: false,
      draft: false,
      page: null,
      loading: 0,
      items: [],
      pageNameList: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1),
    };

    this.onDragEnd = this.onDragEnd.bind(this);
    this.getItems = this.getItems.bind(this);
    this.toast = React.createRef();
  }

  setItem = (currentNumber, type, deleted = false) => {
    type = type ? type : this.state.typeOfContent;
    currentNumber = currentNumber
      ? currentNumber
      : this.state[`${type}_number`];
    let content = null;
    if(!deleted){

      switch (type) {
        case "text": {
          content = (
            <Card title="متن">
              <Button
                  onClick={() => {
                    let text_number =
                      this.state.text_number -1;
   
                    this.setState(
                      {
                        text_number: text_number,
                        [`text_content_${currentNumber}`]: null

                      },
                      () => {
                        this.setItem(currentNumber, "text", true);
                      }
                    );
                  }}
                >
                  <i
                    className="pi pi-trash
                    "
                    style={{ fontSize: "2em" }}
                  ></i>
              </Button>
              <JoditEditor
                value={this.state[`${type}_content_${currentNumber}`]}
                config={htmlAreaConfig}
                tabIndex={1}
                onChange={(value) => {
                  if (value) {
                    const name = `${type}_content_${currentNumber}`;
                    this.setState({ [name]: value });
                  }
                }}
              />
            </Card>
          );
          break;
        }
        case "pic": {
          content = (
            <Card className="row" title="تصویر">
              <Button
                  onClick={() => {
                    let pic_number =
                      this.state.pic_number -1;
                    this.setState(
                      {
                        pic_number: pic_number,
                        [`pic_content_${currentNumber}`]: null
                      },
                      () => {
                        this.setItem(currentNumber, "pic", true);
                      }
                    );
                  }}
                >
                  <i
                    className="pi pi-trash
                    "
                    style={{ fontSize: "2em" }}
                  ></i>
              </Button>
              <UpFile
                className="col-lg-12 col-12 mt-3"
                large={true}
                uploadImage={this.state[`${type}_content_${currentNumber}`]}
                buttonLabel="انتخاب فایل"
                callback={(v) => {
                  this.setState({
                    [`${type}_content_${currentNumber}`]: v.uploadImage,
                  });
                }}
              />
            </Card>
          );
          break;
        }
        case "slider": {
          content = (
            <Card title="اسلایدر">
              <div
                className="col-lg-12 col-12"
                style={{ display: "flex", flexDirection: "row-reverse" }}
              >
                <Button
                  onClick={() => {
                    let CountOfPic =
                      this.state[`${type}_${currentNumber}_CountOfPic`] + 1;
                    this.setState(
                      {
                        [`${type}_${currentNumber}_CountOfPic`]: CountOfPic,
                      },
                      () => {
                        this.setItem(currentNumber, "slider");
                      }
                    );
                  }}
                >
                  <i
                    className="pi pi-plus-circle"
                    style={{ fontSize: "2em" }}
                  ></i>
                </Button>
                <Button
                  onClick={() => {
                    let slider_number =
                      this.state.slider_number -1;
  
                    const content = {};
                    for(let i=0;i< this.state[`slider_${currentNumber}_CountOfPic`];i++){
                      content[`slider_content_${currentNumber}_${i}`] = null;
                    }  
                    this.setState(
                      {
                        slider_number: slider_number,
                        ...content
                      },
                      () => {
                        this.setItem(currentNumber, "slider", true);
                      }
                    );
                  }}
                >
                  <i
                    className="pi pi-trash
                    "
                    style={{ fontSize: "2em" }}
                  ></i>
                </Button>
              </div>
              {Array.from(
                Array(this.state[`${type}_${currentNumber}_CountOfPic`]).keys()
              ).map((item, index) => {
                return (
                  <div className="row">
                    <div className="col-lg-6">
                      <UpFile
                        className="col-lg-6 col-12 mt-3"
                        large={false}
                        uploadImage={
                          this.state[`${type}_content_${currentNumber}_${index}`]
                        }
                        buttonLabel="انتخاب فایل"
                        callback={(v) => {
                          this.setState({
                            [`${type}_content_${currentNumber}_${index}`]:
                              v.uploadImage,
                          });
                        }}
                      />
                    </div>
                  </div>
                );   
              })}
            </Card>
          );
  
          break;
        }
      }
    }
    let items = this.state.items;
    if(deleted){
      items = items.filter((item)=>{
        return item.id != `${type}_content_${currentNumber}`
      })
    }else{
      let edit = false;
      for (let item of items) {
        if (item.id == `${type}_content_${currentNumber}`) {
          edit = true;
          item.content = content;
        }
      }
      if (!edit) {
        items.push({
          id: `${type}_content_${currentNumber}`,
          content: content,
        });
      }
    }
    
    this.setState({
      items: items,
    });
  };

  getItems(count) {
    Array.from({ length: count }, (v, k) => k).map((k) => ({
      id: `item-${k}`,
      content: `item ${k}`,
    }));
  }
  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );
    this.setState({
      items,
    });
  }
  componentDidMount() {
    this.getPage();
  }

  saveChanges() {
    let param = {
      page: this.state.page,
    };
    for (let state in this.state) {
      if (
        state.indexOf("_content_") > -1 ||
        state.indexOf("_CountOfPic") > -1 ||
        state.indexOf("_number") > -1
      ) {
        param[state] = this.state[state];
      }
    }

    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
      this.setState({
        loading: 0,
      });
    };
    let ECallBack = (error) => {
      this.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
      this.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/setPageLayout", param, SCallBack, ECallBack);
  }

  getPage(page) {
    let param = {
      token: localStorage.getItem("api_token"),
      page: page,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      if (response.data.result.length > 1) {
        let pageNameList = [];
        for (let i = 0; i < response.data.result.length; i++) {
          pageNameList.push({
            name: response.data.result[i].page,
            value: response.data.result[i].page,
          });
        }
        this.setState({
          pageNameList: pageNameList,
          loading: 0,
        });
      } else {
        this.setState(response.data.result[0], () => {
          for (let i = 1; i <= this.state.text_number; i++) {
            this.setItem(i, "text");
          }
          for (let i = 1; i <= this.state.pic_number; i++) {
            this.setItem(i, "pic");
          }
          for (let i = 1; i <= this.state.slider_number; i++) {
            this.setItem(i, "slider");
          }
          for (let i = 1; i <= this.state.video_number; i++) {
            this.setItem(i, "video");
          }
          for (let i = 1; i <= this.state.chart_number; i++) {
            this.setItem(i, "chart");
          }
        });
      }
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      console.log(error);
    };

    this.Server.send("AdminApi/getPageLayout", param, SCallBack, ECallBack);
  }

  createPage() {
    for (let p of this.state.pageNameList) {
      if (p.name == this.state.pageName) return;
    }
    let param = {
      token: localStorage.getItem("api_token"),
      page: this.state.pageName,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });

      this.setState({
        loading: 0,
      });
      this.getPage(this.state.pageName);
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      console.log(error);
    };

    this.Server.send("AdminApi/createLayoutPage", param, SCallBack, ECallBack);
  }
  render() {
    return (
      <div style={{ direction: "rtl" }}>
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="ایجاد صفحه جدید"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      style={{ direction: "ltr" }}
                      autoComplete="off"
                      type="text"
                      value={this.state.pageName}
                      name="pageName"
                      onChange={(event) =>
                        this.setState({ pageName: event.target.value })
                      }
                      required="true"
                    />
                    <label>نام لاتین صفحه</label>
                  </div>
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary irsans"
                    onClick={() => this.createPage()}
                    style={{
                      width: "200px",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    {" "}
                    ایجاد صفحه{" "}
                  </button>
                </div>
              </div>
            </Panel>
            <Panel
              header="مدیریت اجزاء صفحه"
              style={{
                marginTop: 20,
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <div className="row">
                <div className="col-lg-4">
                  <label className="labelNoGroup irsans">صفحه جاری</label>
                  <select
                    className="form-control irsans"
                    id="company"
                    name="company"
                    value={this.state.page}
                    onChange={(event) => {
                      const states = {};
                      for (let state in this.state) {
                        if (
                          state.indexOf("_content_") > -1 ||
                          state.indexOf("_CountOfPic") > -1
                        ) {
                          states[state] = "";
                        }
                        if (state.indexOf("_number") > -1) {
                          states[state] = 0;
                        }
                      }
                      this.setState(
                        {
                          page: event.target.value,
                          PageLink: `https://${window.location.hostname}/#/Pages/?id=${event.target.value}`,
                          items: [],
                          ...states,
                        },
                        () => {
                          this.getPage(event.target.value);
                        }
                      );
                    }}
                    style={{ marginBottom: 20 }}
                  >
                    <option value={null}></option>
                    {this.state.pageNameList &&
                      this.state.pageNameList.map((v, i) => {
                        return <option value={v.name}>{v.name}</option>;
                      })}
                  </select>
                </div>
                <div className="col-lg-4">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      disabled
                      style={{ direction: "ltr" }}
                      autoComplete="off"
                      type="text"
                      value={this.state.PageLink}
                      name="PageLink"
                      onChange={(event) =>
                        this.setState({ PageLink: event.target.value })
                      }
                      required="true"
                    />
                    <label>لینک صفحه</label>
                  </div>
                </div>
                <div className="col-lg-12">
                  <SelectButton
                    optionLabel="label"
                    optionValue="value"
                    value={this.state.typeOfContent}
                    options={[
                      {
                        value: "text",
                        label: "متن",
                      },
                      {
                        value: "pic",
                        label: "تصویر",
                      },
                      {
                        value: "slider",
                        label: "اسلایدر",
                      },
                      {
                        value: "video",
                        label: "ویدیو",
                      },
                      {
                        value: "chart",
                        label: "نمودار",
                      },
                    ]}
                    onChange={(e) => {
                      this.setState({
                        typeOfContent: e.value,
                      });
                    }}
                  ></SelectButton>
                </div>
                <div className="col-lg-12 mt-5 mb-2">
                  <Button
                    onClick={(event) => {
                      let number =
                        this.state[`${this.state.typeOfContent}_number`] + 1;
                      let newState = {
                        [`${this.state.typeOfContent}_number`]: number,
                      };
                      if (this.state.typeOfContent == "slider") {
                        newState[
                          `${this.state.typeOfContent}_${number}_CountOfPic`
                        ] = 1;
                      }
                      this.setState(newState, () => {
                        this.setItem();
                      });
                    }}
                  >
                    اضافه کردن (
                    {this.state[`${this.state.typeOfContent}_number`]})
                  </Button>
                </div>
                <DragDropContext
                  onBeforeCapture={this.onBeforeCapture}
                  onBeforeDragStart={this.onBeforeDragStart}
                  onDragStart={this.onDragStart}
                  onDragUpdate={this.onDragUpdate}
                  onDragEnd={this.onDragEnd}
                >
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {this.state.items &&
                          this.state.items.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{ marginTop: 20, marginBottom: 20 }}
                                >
                                  {item.content}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <div>
                  <button
                    className="btn btn-primary irsans"
                    onClick={() => this.saveChanges()}
                    style={{
                      width: "200px",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    {" "}
                    اعمال{" "}
                  </button>
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(FirstPageLayout);
